import { Article } from "./types/article"

const articles = [
  new Article({
    title: "Why Good Managers Are So Rare",
    link: "/articles/good-managers",
    excerpt: `
    Managers account for at least 70% of variance in employee engagement scores across business units, Gallup estimates.
    This variation is in turn responsible for severely low worldwide employee engagement. Gallup reported in two large-scale studies in 2012 that only 30% of
     U.S. employees are engaged at work, and a staggeringly low 13% worldwide are engaged. Worse, over the past 12 years these low numbers have barely budged, meaning
     that the vast majority of employees worldwide are failing to develop and contribute at work.
    `,
    categories: ["Management", "Leadership", "Blog", "Communication"],
    date: new Date("2019-01-13"),
    highlighted: true,
    image: require("../images/good-managers.jpg"),
  }),
  new Article({
    title: "Develop Deep Knowledge in Your Organization",
    link: "/articles/deep-knowledge",
    excerpt: `
    The best leaders understand that the current success of their business, and any future innovation, depends upon the “deep smarts” of their employees —
    the business-critical, experience-based knowledge that employees carry with them. Leaders with a passion for developing employees’ skills, and those
    who understand the need to transfer knowledge among generations of workers, know how important it is to link in-house education to strategic planning.
    `,
    categories: ["Management", "Leadership", "Communication"],
    date: new Date("2018-11-09"),
    highlighted: true,
    image: require("../images/deep-knowledge.jpg"),
  }),
  new Article({
    title: "Rules for Designing an Engaging Workplace",
    link: "/articles/designing-a-workplace",
    excerpt: `
    Environmental psychologists are the design mavens of the scientific world. We’re the folks who concentrate our attention on how
    sensory experiences, psychosocial factors such as needing a territory, and basic psychological drives like having control over our
    physical environment, interact with personality and national culture to influence how attitudes and actions are affected by being in
    one space or another. Several dozen of us, working around the world, are moving what scientists have learned about how humans experience
    space from the dark corners of academia into the light of design practice, where it can make people’s lives better.
    `,
    categories: ["Management", "Design"],
    date: new Date("2018-09-21"),
    highlighted: true,
    image: require("../images/designing-a-workplace.png"),
  }),
  new Article({
    title: "Motivating People to Perform at Their Peak",
    link: "/articles/motivating-people",
    excerpt: `
    Over the past decades, scientific research has provided compelling evidence for the idea that engaged employees perform better,
    are less likely to leave or burn out, and more likely to display organizational citizenship. Employee engagement has also been found
    to correlate positively with business level performance and other measures of organizational effectiveness.    `,
    categories: ["Management", "Leadership", "Communication"],
    date: new Date("2016-08-09"),
    highlighted: false,
    image: require("../images/motivating-people.jpg"),
  }),
  new Article({
    title: "Bring Agile to the Whole Organization",
    link: "/articles/agile-organization",
    excerpt: `
    Software has eaten the world. And as it continues to consume new and diverse industries
    it’s transforming the way business is done. We are all in the “software business” now,
    regardless of the product or service we provide, forcing us to reexamine how we structure and manage our organizations.
    `,
    categories: ["Blog", "Management", "Leadership"],
    date: new Date("2016-06-12"),
    highlighted: false,
    image: require("../images/agile-organization.jpg"),
  }),
  new Article({
    title: "5 Ways Product Design Needs to Evolve for the Internet of Things",
    link: "/articles/product-design",
    excerpt: `
    What does product design mean when products are no longer just physical goods?
    That’s the difficult question facing designers today. When machines are both
    connected and intelligent, they become a hybrid of products and services.
    `,
    categories: ["Blog", "Design", "Management"],
    date: new Date("2016-04-04"),
    highlighted: false,
    image: require("../images/product-design.jpg"),
  }),
  new Article({
    title: "What Leaders Really Do",
    link: "/articles/what-leaders-really-do",
    excerpt: `Leadership is different from management, but not for the reasons most people think.
      Leadership isn’t mystical and mysterious.
      It has nothing to do with having “charisma” or other exotic personality traits.
      It is not the province of a chosen few. Nor is leadership necessarily better than management
      or a replacement for it.`,
    categories: ["Leadership", "Management"],
    date: new Date("2016-04-03"),
    highlighted: false,
    image: require("../images/what-leaders-really-do.jpg"),
  }),
]

export class Articles {
  static list() {
    return articles
  }

  static getHighlighted(cat) {
    return articles.filter(a => a.highlighted && (!cat || a.hasCategory(cat)))
  }

  static getNonHighlighted(cat) {
    return articles.filter(a => !a.highlighted && (!cat || a.hasCategory(cat)))
  }

  static getBySlug(slug) {
    return articles.find(a => a.link === `/articles/${slug}`)
  }

  static getByCategory(cat) {
    return articles.filter(a => a.hasCategory(cat))
  }

  static getOneByCategory() {
    const categories = Articles.getUniqueCategories()

    const articlesByCategory = []

    categories.forEach(cat => {
      articles.some(a => {
        if (
          a.hasCategory(cat) &&
          !articlesByCategory.find(ac => ac.article.link === a.link) &&
          !a.highlighted
        ) {
          articlesByCategory.push({
            article: a,
            category: cat,
          })
          return true
        }
        return false
      })
    })

    return articlesByCategory
  }

  static getUniqueCategories(max) {
    return Array.from(
      articles.reduce((acc, el) => {
        el.categories.forEach(c => acc.add(c))
        return acc
      }, new Set())
    ).slice(0, max ? max : undefined)
  }

  static getLatest(n) {
    return articles.sort((a, b) => a.date > b.date).slice(0, n)
  }
}
